import limitValue from "../../../../utils/limit-value";
import round from "../../../../utils/round";
import WINDOW from "../../../../utils/window";
import getCoordsStartEnd from "../percents/get-coords-start-end";

/**
 *
 * @param {TriggerProps} trigger
 * @param {"x" | "y"} axis
 */
const getPointerDefaultPercents = (trigger, axis) => {
  const pointer = /** @type {WindowCoordinatesProps} */ (WINDOW.get("pointer"));

  const start = getCoordsStartEnd(trigger, "start", axis);
  const end = getCoordsStartEnd(trigger, "end", axis);

  const position = /** @type {Number} */ (pointer.get(axis));
  const percents = (position - start) / (end - start);

  return limitValue(round(percents));
};

export default getPointerDefaultPercents;
